import { useSelector } from 'store'

// 詳細画面のページ //================================//
export const usePageDetail = (): [number, number] => {
  const pageDetail = useSelector((state) => state.TableReducer.pageDetail)
  const perPageDetail = useSelector((state) => state.TableReducer.perPageDetail)
  return [pageDetail, perPageDetail]
}

// ページ //================================//
export const usePage = (): [number, number] => {
  const page = useSelector((state) => state.TableReducer.page)
  const perPage = useSelector((state) => state.TableReducer.perPage)
  return [page, perPage]
}
